import { render, staticRenderFns } from "./Travellist.vue?vue&type=template&id=cef73424&scoped=true"
import script from "./Travellist.vue?vue&type=script&lang=js"
export * from "./Travellist.vue?vue&type=script&lang=js"
import style0 from "./Travellist.vue?vue&type=style&index=0&id=cef73424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef73424",
  null
  
)

export default component.exports